module.exports = __webpack_public_path__ + "img/furnitureshop-grid-slider-02.51f5cf21.png";